<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-form ref="form" v-model="valid" :lazy-validation="lazy">
    <DialogSendEMail ref="dialog"/>
    <v-container class="pt-0">
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card flat color="white">
            <v-card-title class="headline font-weight-thin bluetext mt-1 pb-0 pt-0">
              {{'TITLE_CONTACT_SUPPORT' | translate}}
            </v-card-title>
            <v-card-title class="body-1 font-weight-thin bluetext text-xs-left py-2">
              {{'SUBTITLE_CONTACT_SUPPORT' | translate}}
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card flat color="transparent">
            <v-layout wrap row justify-space-between>
              <v-flex
                xs12
                class="px-2"
              >

                <v-select
                  :items="items"
                  :label="subject"
                  v-model="formData.subject"
                  :rules="[rules.required]"
                  solo
                  class="heightLogin"
                  required
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout wrap row justify-space-between>
              <v-flex
                xs12
                class="px-2"
              >
                <v-text-field solo class="heightLogin" :label="mail" :rules="emailRules" required
                              v-model="formData.email"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <!--<v-layout wrap row justify-space-between>
              <v-flex
                xs12
                class="px-2"
              >
                <v-text-field solo class="heightLogin"
                              :label="subjectmatter"
                              v-model="formData.subjectmatter"
                              :rules="[rules.required]"
                              required>
                </v-text-field>
              </v-flex>
            </v-layout>-->


            <v-flex
              xs12
              sm12
              class="px-2"
            >
              <v-textarea
                solo
                class="heightLogin"
                v-model="formData.nachricht"
              >
              </v-textarea>
            </v-flex>
            <!--<v-layout row class="mb-3">
              <v-flex xs12>
                <v-checkbox
                  :rules="[rules.required]"
                  color="#004884"
                  v-model="formData.agree"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      {{'CHECKBOX_LEGALNOTICE1' | translate}}
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href="https://www.creditreform.de/datenschutz"
                            @click.stop
                            v-on="on"
                          >
                            {{'LEGALNOTICE' | translate}}
                          </a>
                        </template>
                        {{'TOOLTIP_LEGALNOTICE' | translate}}
                      </v-tooltip>
                      {{'CHECKBOX_LEGALNOTICE2'| translate}}
                      <a
                        href="mailto:info@creditreform-rating.de"
                        @click.stop
                      >
                        {{'EMAIL_LEGALNOTICE' | translate}}
                      </a>
                      {{'CHECKBOX_LEGALNOTICE3'| translate}}
                    </div>
                  </template>


                </v-checkbox>


              </v-flex>
            </v-layout> -->
           <!-- <vue-recaptcha @verify="onVerify"
                           size="invisible"
                           @expired="onExpired" ref="invisibleRecaptcha"
                           sitekey="6LfIobcUAAAAAIOAvpfcwwDtoDExve5s3Tpwgh-4" :loadRecaptchaScript="true">
            </vue-recaptcha>-->
            <v-card-actions>
              <v-layout>
                <v-btn color="blue" dark small class="font-weight-bold text-none" @click="goPortal">
                  {{'BUTT_BACK' | translate}}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue" dark small class="font-weight-bold text-none" @click="onSubmit">
                  {{'BUTT_SEND' | translate}}
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import Vue from 'vue'
// import VueRecaptcha from 'vue-recaptcha'
import DialogSendEMail from './../module/dialogs/DialogSendEMail'

export default {
  name: 'ContactForm',
  components: {DialogSendEMail},
  methods: {
    goPortal: function () {
      this.$router.push('/Login')
    },
    onClick: function () {
      window.history.back()
    },
    doCancel: function () {
      Vue.prototype.$api.debug('doCancle')
      this.$emit('cancel')
    },
    onSubmit: function () {
      if (!this.$refs.form.validate()) {
        Vue.prototype.$api.debug('missing values')
        return
      }
      Vue.prototype.$api.debug('doSend')
      try {
        this.$refs.invisibleRecaptcha.execute()
      } catch (e) {
        this.onVerify('noCaptcha')
      }
    },
    onVerify: function (response) {
      Vue.prototype.$api.debug('Verify: ' + response)
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.register(response, this.formData, this.onRegister)
    },
    onRegister: function () {
      Vue.prototype.$api.hideIdle()
      this.$refs.dialog.open()
    },
    onExpired: function () {
      Vue.prototype.$api.debug('Expired')
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
    }
  },
  data () {
    return {
      formData: {
        subject: '',
        subjectmatter: '',
        nachricht: ''
      },
      valid: true,
      mail: Vue.i18n.translate('FORM_MAIL'),
      mailto: Vue.i18n.translate('EMAIL_SUPPORT'),
      email: '',
      emailRules: [
        v => /.+@.+/.test(v) || Vue.i18n.translate('FORM_MAILRULE')
      ],
      menu: false,
      lazy: false,
      subject: Vue.i18n.translate('SUBJECT'),
      subjectmatter: Vue.i18n.translate('SUBJECT_MATTER'),
      yourmessage: Vue.i18n.translate('FORM_MESSAGE_PASSWORD_FORGOT'),
      items: [Vue.i18n.translate('SUBJECT_PASSWORD_FORGOT')],
      rules: {
        required: value => !!value || Vue.i18n.translate('FORM_REQUIRED')
      }
    }
  },
  mounted () {
    this.formData.subject = this.items[0]
    // Vue.prototype.$api.checkCredentials(this)

    this.formData.nachricht = Vue.i18n.translate('FORM_MESSAGE_PASSWORD_FORGOT')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/ContactForm_Support_offline.vue